import { render } from "./i18n-flags.vue?vue&type=template&id=497beb56&ts=true"
import script from "./i18n-flags.vue?vue&type=script&lang=ts"
export * from "./i18n-flags.vue?vue&type=script&lang=ts"

import "./i18n-flags.vue?vue&type=style&index=0&id=497beb56&lang=css"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__